const regionNotification = document.querySelector('#region-notification');

document.addEventListener('DOMContentLoaded', function () {
  if (regionNotification) {
    if (localStorage.getItem('show_region_notif') === 'true') {
      regionNotification.style.display = 'block';
      setTimeout(function () {
        regionNotification.style.display = 'none';
        localStorage.setItem('show_region_notif', false);
      }, 5000);
    } else {
      regionNotification.style.display = 'none';
      localStorage.setItem('show_region_notif', false);
    }
  }
});

function setUserLocalizationPreference(countryCode, languageCode) {
  document.cookie = `localization=${countryCode};path=/;max-age=31536000`;
  redirectToLocalization(countryCode, languageCode);
}

function checkAndRedirectIfNecessary() {
  const localeBarAccepted = getCookie('is_in_locale');

  if (localeBarAccepted !== '1' || localeBarAccepted === null) {
    fetch(
      window.Shopify.routes.root +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}` +
        '&language[enabled]=true' +
        '&language[exclude]=English'
    )
      .then((r) => r.json())
      .then((data) => {
        if (data && data.suggestions && data.suggestions.length > 0) {
          const detectedValue = data.detected_values.country;
          const suggestion = data.suggestions[0].parts;

          if (
            detectedValue.handle !== window.Shopify.country ||
            suggestion.language.handle !== window.Shopify.locale
          ) {
            setUserLocalizationPreference(detectedValue.handle, suggestion.language.handle);
            localStorage.setItem('show_region_notif', true);
            //set cookie
            setCookie('is_in_locale', '1');
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching localization data:', error);
      });
  } else {
    console.log('Localization is already set to user preference.');
    if (regionNotification) {
      document.querySelector('#region-notification').style.display = 'none';
    }
  }
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

//set cookie
function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

function redirectToLocalization(countryCode, languageCode) {
  const newPath = `/${languageCode}-${countryCode}/`;
  if (window.location.pathname !== newPath) {
    window.location.pathname = newPath;
    localStorage.setItem('show_region_notif', false);
    if (regionNotification) {
      regionNotification.style.display = 'block';
    }
    setTimeout(function () {
      if (regionNotification) {
        regionNotification.style.display = 'none';
      }
    }, 5000);
  } else {
    console.log('User is already at the desired localization URL.');
  }
}

// Initialize the check
checkAndRedirectIfNecessary();
